import React, {Component} from 'react';
import {connect} from "react-redux";
import NavLink from 'react-router-dom/es/NavLink';
import Lookup from '../Lookup/Lookup';
import withRouter from "react-router/es/withRouter";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import Select from "../Select/Select";
import Skeleton from "../Skeleton/Skeleton";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import FacilitiesHolidayHours from "../../components/FacilitiesHolidayHours/FacilitiesHolidayHours";

const mapStateToProps = (state) => {
    return {
        rawFacilities: state.facilitiesData.rawFacilities,
        serviceError: state.facilitiesData.error
    }
};

const mapDispatchToProps = dispatch => ({
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA})
});

const sortFacilities = (prev, next) => {
    const prevFacility = prev.name ;
    const nextFacility = next.name ;

    if (prevFacility < nextFacility) {
        return -1;
    }
    if (prevFacility > nextFacility) {
        return 1;
    }
    return 0;
};

class FacilitiesSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedAirportCodeFromLookup: '',
            selectedCountry: 'US',
            selectedState: '',
            selectedAirportCodeFromDropdown: '',
            displayState: ''
        }
    }

    componentDidMount() {
        if (!this.props.rawFacilities) {
            this.props.getRawFacilities();
        }
    };

    getFacilitiesList = () => {
        return this.props.rawFacilities.map((facility) => {
            return {
                name: `${(facility.commonAirportName) ? facility.commonAirportName + ", " : ""}${facility.facilityInfo.location.stateName} - ${facility.airportCodeIATA}`,

                airportCode: facility.airportCodeIATA,
                airportName: facility.commonAirportName,
                value: facility.airportCodeIATA
            }
        });
    };

    navigateToSelectedFacilityFromLookup = (event) => {
        event.preventDefault();
        if (this.state.selectedAirportCodeFromLookup) {
            this.props.history.push({
                pathname: `/ship/facilities/facility`,
                search: `airportCode=${this.state.selectedAirportCodeFromLookup}`
            })
        }
    };

    navigateToSelectedFacilityFromDropdown = () => {
        if (this.state.selectedAirportCodeFromDropdown) {
            this.props.history.push({
                pathname: `/ship/facilities/facility`,
                search: `airportCode=${this.state.selectedAirportCodeFromDropdown}`
            })
        }
    };

    selectedAirportCodeHandler = (airportCode) => {
        this.setState({
            selectedAirportCodeFromLookup: airportCode
        })
    };

    getListOfCountries = () => {
        return this.props.rawFacilities
        // Filter Duplicates
                .filter((facility, index, facilities) => {
                    let isDuplicate = false;

                    for (let i = 0; i < index; i++) {
                        if (facilities[i].facilityInfo.location.countryName === facility.facilityInfo.location.countryName) {
                            isDuplicate = true;
                        }
                    }

                    return !isDuplicate
                })
                .map((facility) => {
                    return {
                        name: facility.facilityInfo.location.countryNameDescription ?
                                facility.facilityInfo.location.countryNameDescription.toUpperCase() :
                                facility.facilityInfo.location.countryName.toUpperCase(),
                        value: facility.facilityInfo.location.countryName
                    }

                })
                .sort(sortFacilities);
    };

    getListOfStatesWithinCountry = () => {

        return this.state.selectedCountry ? this.props.rawFacilities
        // Filter Empty States
                .filter((facility) => {
                    return facility.facilityInfo.location.stateName
                })
                // Filter Only States From Selected Country
                .filter((facility) => {
                    return facility.facilityInfo.location.countryName === this.state.selectedCountry
                })
                // Filter Duplicates
                .filter((facility, index, facilities) => {

                    let isDuplicate = false;

                    // Search duplicates before
                    for (let i = 0; i < index; i++) {
                        if (facilities[i].facilityInfo.location.stateName === facility.facilityInfo.location.stateName) {
                            isDuplicate = true;
                        }
                    }

                    return !isDuplicate
                })
                .map((facility) => {
                    return {
                        name: facility.facilityInfo.location.stateName,
                        value: facility.facilityInfo.location.stateName
                    }
                })
                .sort(sortFacilities) : [];
    };

    getListOfCommonAirportsWithinStateOrCountry = () => {
        const isSelectedCountryUSOrCA = (this.state.selectedCountry === 'US' || this.state.selectedCountry === 'CA');
        return ((isSelectedCountryUSOrCA && this.state.selectedState) || (!isSelectedCountryUSOrCA && this.state.selectedCountry)) ? this.props.rawFacilities
        // Filter Empty States
                .filter((facility) => {
                    return facility.facilityInfo.location.cityName
                })
                // Filter Only States From Selected Country
                .filter((facility) => {
                    return (isSelectedCountryUSOrCA && facility.facilityInfo.location.stateName === this.state.selectedState) ||
                            (!isSelectedCountryUSOrCA && facility.facilityInfo.location.countryName === this.state.selectedCountry)
                })
                .map((facility) => {
                    return {
                        name: `${facility.commonAirportName}`,
                        value: facility.airportCodeIATA
                    }
                })
                .sort(sortFacilities) : [];
    };

    setSelectedCountry = (event) => {
        const selectedCountry = event.target.value;
        this.setState({
            selectedCountry: selectedCountry === 'Please select...' ? '' : selectedCountry,
            selectedState: '',
            selectedAirportCode: '',
            displayState: (selectedCountry !== 'US' && selectedCountry !== 'CA') ? ' hidden' : ''
        });
    };

    setSelectedState = (event) => {
        const selectedState = event.target.value;
        this.setState({
            selectedState: selectedState === 'Please select...' ? '' : selectedState,
            selectedAirportCode: ''
        });
    };

    setSelectedAirport = (event) => {
        const selectedAirport = event.target.value;
        this.setState({
            selectedAirportCodeFromDropdown: selectedAirport === 'Please select...' ? '' : selectedAirport
        })
    };
    handleAllFacilitiesSubmit = (event) => {
        event.preventDefault();
        this.props.history.push("./facilities/allFacilities");
    }

    getPageView = () => (
            <div>
                <div className="facilities-search-layout">
                    <div className="facilities-search-layout__column-main">
                        <h1 className="two-three-rows__title facilities-search__heading">Facilities</h1>
                        <p className="two-three-rows__description">
                            No matter where you are, there’s a cargo facility near you. Enter your information below to find the closest
                            one.
                        </p>
                        <div className="facilities-search__main-search">
                            <form onSubmit={this.navigateToSelectedFacilityFromLookup.bind(this)}>
                                <label className="input-label">City or Airport Code</label>
                                <Lookup
                                        dataList={this.getFacilitiesList()}
                                        onChange={this.selectedAirportCodeHandler}
                                />
                                <button
                                        type="submit"
                                        className="cta-button facilities-search-button">
                                    Search
                                </button>

                                <button type="button" className="all-facilities-button" onClick={this.handleAllFacilitiesSubmit.bind(this)}>All Facilities</button>
                            </form>
                        </div>
                        <p>
                            Or look up a location by country, state and city.
                        </p>
                        <div className="facilities-search-country-state-city-wrapper">
                            <div className="facilities-search__alternative-search">
                                <Select
                                        hasPleaseSelectOption={true}
                                        name="country"
                                        title="Country"
                                        selected={this.getListOfCountries().find(country => country.value.toUpperCase() === 'US')}
                                        options={this.getListOfCountries()}
                                        onChange={this.setSelectedCountry}
                                        desktopWidth={'100%'}
                                        tabletWidth={'100%'}
                                        mobileWidth={'100%'}
                                />
                            </div>
                            <div className={'facilities-search__alternative-search' + this.state.displayState}>
                                <Select
                                        hasPleaseSelectOption={true}
                                        name="state"
                                        title="State/Province"
                                        options={this.getListOfStatesWithinCountry()}
                                        onChange={this.setSelectedState}
                                        resetOnPropsUpdate={true}
                                        desktopWidth={'100%'}
                                        tabletWidth={'100%'}
                                        mobileWidth={'100%'}
                                />
                            </div>
                            <div className="facilities-search__alternative-search">
                                <Select
                                        hasPleaseSelectOption={true}
                                        name="airport"
                                        title="Airport"
                                        options={this.getListOfCommonAirportsWithinStateOrCountry()}
                                        onChange={this.setSelectedAirport}
                                        resetOnPropsUpdate={true}
                                        desktopWidth={'100%'}
                                        tabletWidth={'100%'}
                                        mobileWidth={'100%'}
                                />
                            </div>
                        </div>
                        <button
                                type="submit"
                                className="cta-button facilities-search-button"
                                onClick={this.navigateToSelectedFacilityFromDropdown.bind(this)}
                        >Search
                        </button>
                    </div>
                    <div className="facilities-search-layout__column-table">
                        <FacilitiesHolidayHours/>
                    </div>
                </div>
                <div className="facilities-search-facility-map__header">Facility Map</div>
                <div className="facilities-search-facility-map">
                    <ContentPanel
                            skeleton={<Skeleton type="LONG_CONTENT_PAGE"/>}
                            errorTemplate={<Skeleton type="LONG_CONTENT_PAGE_ERROR"/>}
                            templateUrl="./content/ship/page-components/content-detail/facility-map.html"
                    />
                </div>
                <div className="facilities-search-additional-resources-label">Additional Resources</div>
                <NavLink to="/ship/facilities/interline-destinations/" className="facilities-search-interline-destinations">
                    Interline Destinations
                </NavLink>

            </div>
    );

    getErrorMessage = () => {
        if (this.props.serviceError) {
            return 'This feature is currently not available. Please try again. If the error continues, please call our Cargo Customer Care Center at 1 (800) 533-1222.';
        }
    };

    render() {
        if (this.props.serviceError) {
            return (
                    <div>
                        <h1 className="two-three-rows__title facilities-search__heading">Facilities</h1>
                        <p className="two-three-rows__description">
                            No matter where you are, there’s a cargo facility near you. Enter your information below to find the closest
                            one.
                        </p>
                        <div className="tracking-advanced-search-error-wrapper alert alert-danger">
                            {this.getErrorMessage()}
                        </div>
                    </div>
            );
        }
        return this.props.rawFacilities ? this.getPageView() : <Skeleton type="LONG_CONTENT_PAGE"/>;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilitiesSearch));



// WEBPACK FOOTER //
// ./src/components/FacilitiesSearch/FacilitiesSearch.js